// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v5.5.1-jSoAt0XH0RmA5q5lMsh2/mode=imports,min/optimized/keen-slider.js'

class SectionArticles extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els.slide || this.els.slide.elements.length < 2) return

    if (window.innerWidth < 768) {
      this.carousel = this.initialiseCarousel()
      this.els.slides.element.classList.add('car-Carousel_Slides')

      this.els.slide.elements.forEach(slide => {
        slide.classList.add('car-Carousel_Slide')
      })
    }

    this.carousel = this.initialiseCarousel()
    this.setupListeners()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(window, 'resize', this.carouselSwitcher.bind(this))
  }

  carouselSwitcher () {
    if (window.innerWidth > 767) {
      this.els.slides.element.classList.remove('car-Carousel_Slides')

      this.els.slide.elements.forEach(slide => {
        slide.classList.remove('car-Carousel_Slide')
      })
      this.els.slide.elements.forEach(slide => {
        slide.style.setProperty('max-width', '')
        slide.style.setProperty('transform', '')
        slide.style.setProperty('min-width', '')
      })
    } else {
      this.carousel = this.initialiseCarousel()
      this.els.slides.element.classList.add('car-Carousel_Slides')

      this.els.slide.elements.forEach(slide => {
        slide.classList.add('car-Carousel_Slide')
      })
    }
  }

  initialiseCarousel () {
    return new KeenSlider(this.els.slides.element, {
      loop: false,
      mode: 'snap',
      slidesPerView: 1.1,
      slides: '.car-Carousel_Slide',
      spacing: 20,
      move: instance => {
        if (this.els.progress.element) {
          const progressTrack = instance.details().progressTrack
          const progressAmount = progressTrack >= 1 ? 0 : progressTrack
          const movementPercentage = progressAmount * 100
          this.els.progress.element.style.setProperty(
            '--progress',
            `${movementPercentage}%`,
          )
        }
      },
      created: instance => {
        this.setAttribute(`data-initialised`, true)
      },
    })
  }
}

customElements.define('section-articles', SectionArticles)
